/*export  var Global = {
    url:'http://localhost/api',
    url_storage:'http://localhost/storage',
    system: 'airbox'
    
};*/

export const Global = {
    url: window.location.origin + '/api',
    url_storage: window.location.origin + '/storage',
    system: 'airbox'
  };